import { render } from "./AssignSpeakerCategoryModal.vue?vue&type=template&id=5e755840"
import script from "./AssignSpeakerCategoryModal.vue?vue&type=script&lang=js"
export * from "./AssignSpeakerCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__